import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import AuthContextProvider from 'Shared/Security/Domain/Contexts/authContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es';
import { AppRouter } from 'Shared/Routing/Application/Routers/AppRouter';
import appTheme from 'UI/theme';

// Check if required environment variables are set
if (
  !process.env.REACT_APP_BACKEND_URL ||
  !process.env.REACT_APP_TOKEN_NAME ||
  !process.env.REACT_APP_REFRESH_TOKEN_NAME
) {
  throw new Error("Missing required environment variable.");
}

const router = createBrowserRouter(AppRouter, {basename: process.env.PUBLIC_URL});

function App() {
  return (
    <AuthContextProvider>
      <ThemeProvider theme={appTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
          <ToastContainer />
          <RouterProvider router={router} />
        </LocalizationProvider>
      </ThemeProvider>
    </AuthContextProvider>
  );
}

export default App;
